<template>
  <div class="admin-template-edit">
    <div class="toolbar justify-content-between">
      <div>
        <i class="icon-button" :class="$config.icons.general.back" v-b-tooltip title="Back to Admin" @click="clickBack"></i>
      </div>
      <div>

      </div>
    </div>
    <div class="list-containter">
      <b-card>
        <b-card-header><h2>Data Link Edit</h2></b-card-header>
        <b-card-body class="template-body">
          <AdminEditDataLink :link_id="linkId" v-if="linkId"></AdminEditDataLink>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>


import AdminEditDataLink from '@/components/admin/AdminEditDataLink.vue'

export default {
  name: 'admin-templates',
  components: {
    AdminEditDataLink,
  },
  data: function () {
    return {
      linkId: null
    }
  },
  mounted() {
    if (Object.hasOwn(this.$route.params, 'link_id')) {
      console.log('Link Id : ', this.$route.params.link_id)
      this.linkId = this.$route.params.link_id
    }
  },
  methods: {
    clickBack: function () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../variables';

  .admin-task {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 2%;
    overflow-y: auto;
  }

  .list-containter {
    background: $theme-color-background-4;
    border-radius: 5px;
    padding: 5px;
    margin: 5px;
  }

  .toolbar {
    width: 100%;
    display: flex;
    flex-direction: row;
    font-size: 3rem;
  }

  .template-body {
    overflow: auto;
    max-height: 85vh;
  }

</style>
